import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// Nebular icon module
import { NbIconModule } from '@nebular/theme';

import { SidebarComponent } from './sidebar.component';
import { SidebarHeaderComponent } from './sidebar-header/sidebar-header.component';
import { SidebarMainContentComponent } from './sidebar-main-content/sidebar-main-content.component';
import { SidebarFooterComponent } from './sidebar-footer/sidebar-footer.component';

// Translate module
import { TranslateModule } from '@ngx-translate/core';

import { GenerateSidebarLinkPipe } from '@app/shared/pipes/generate-sidebar-link.pipe';
import { DrirectivesModule } from '@app/shared/directives/drirectives.module';
import { SidebarSubitemsComponent } from './sidebar-main-content/sidebar-subitems/sidebar-subitems.component';
import { LoaderComponent } from '../loader/loader.component';

@NgModule({
  declarations: [
    SidebarComponent,
    SidebarHeaderComponent,
    SidebarMainContentComponent,
    SidebarFooterComponent,
    GenerateSidebarLinkPipe,
    SidebarSubitemsComponent,
    LoaderComponent
  ],
  imports: [CommonModule, NbIconModule, TranslateModule, RouterModule, DrirectivesModule],
  exports: [SidebarComponent, LoaderComponent]
})
export class SidebarModule {}
